/**
 * Legacy AuthService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.auth`) keep resolving.
 *
 * The actual `AuthService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts as a downgrade
 * of the unified Angular 18 AuthenticationService.
 *
 * Do NOT register `.service('AuthService', ...)` here — it would shadow the
 * downgraded service.
 */
angular.module('acme.common.service.auth', [
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.featureToggle',
]);
